export namespace IUploadFiles {
  export enum Action {
    UploadFile = 'upload_file',
  }
}